export var breakpointWidth100 = "320px";
export var breakpointWidth200 = "375px";
export var breakpointWidth300 = "834px";
export var breakpointWidth400 = "1152px";
export var breakpointWidth500 = "1440px";
export var breakpointWidthMobile = "375px";
export var breakpointWidthTablet = "834px";
export var breakpointWidthDesktop = "1152px";
export var breakpointHeight100 = "568px";
export var breakpointHeight200 = "667px";
export var breakpointHeight300 = "1194px";
export var breakpointHeight400 = "700px";
export var breakpointHeight500 = "1024px";
export var breakpointHeightMobile = "375px";
export var breakpointHeightTablet = "834px";
export var breakpointHeightDesktop = "1152px";